// import React, { useEffect, useState } from 'react';
// import { getFirestore } from "../../config/firebase";
// import logoWhatsapp from '../../assets/logoWhatsapp.png';
// import './whatsapp.scss';

// const WhatsAppFlotante = () => {

//     const [numerosWhatsapp, setNumerosWhatsapp] = useState([]);
//     const [mostrarWhatsapp, setMostrarWhatsapp] = useState(false);

//     useEffect(() => {
//         const db = getFirestore();
//         const vehicles = db.collection("peugeot-informacion");

//         vehicles.get().then((querySnapshot) => {
//             const datosCompletos = querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
//           setNumerosWhatsapp(datosCompletos[1].numeros);
//           setMostrarWhatsapp(datosCompletos[1].mostrar)
//         });

//       }, []);

//     const [open, setOpen] = useState(false);

//    if(!mostrarWhatsapp) {
//         return null;
//     }

//     return (
//         <div className="whatsapp-container">
//             <div className={open ? 'whatsapp-oculto activo' : 'whatsapp-oculto'}>
//                 {
//                     numerosWhatsapp.map((numero,index) => (
//                         numero.habilitado ? (
//                             <a href={numero.url} target="_blank" key={index} rel="noreferrer">
//                                 <img src={logoWhatsapp} alt="whatsapp" />
//                                 <span>{numero.nombre}</span>
//                             </a>
//                         ) : null

//                     ))

//                 }

//             </div>
//             <button  className='btn-whatsapp-flotante' onClick={() => setOpen(!open)}>
//                 <img src={logoWhatsapp} alt="whatsapp" />
//             </button>
//         </div>
//     );
// }
// export default WhatsAppFlotante;

import React, { useEffect, useState } from "react";
import { getFirestore } from "../../config/firebase";
import logoWhatsapp from "../../assets/logoWhatsapp.png";
import "./whatsapp.scss";
import useFirestoreUpdate from "../../config/useFirestoreData";
import { getUtmParams } from "../../config/whatsappConfig";
import WhatsAppModal from "./WhatsAppModal";

const WhatsAppFlotante = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { updateData } = useFirestoreUpdate("consultas", "validaciones");

  const handleModalSubmit = async (values) => {
    setLoading(true);
    try {
      await updateData(values);
      setOpen(false);
      // Construir la URL con origen CONSULTA WEB
      const currentUrl = new URL(window.location.href);
      const { utm_medium } = getUtmParams();
      currentUrl.searchParams.set("utm_source", "CONSULTA WEB");
      currentUrl.searchParams.set("utm_medium", utm_medium);
      const urlWithUtm = currentUrl.toString();

      // Construir el mensaje de WhatsApp
      const whatsappMessage = `Hola, me gustaría hacer una consulta.\n${urlWithUtm}`;
      const encodedMessage = encodeURIComponent(whatsappMessage);
      window.location.href = `https://api.whatsapp.com/send?phone=5493513793585&text=${encodedMessage}`;
    } catch (error) {
      alert("Ocurrió un error al guardar los datos. Intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="whatsapp-container">
      <WhatsAppModal open={open} onClose={() => setOpen(false)} onSubmit={handleModalSubmit} loading={loading} />
      <button className="btn-whatsapp-flotante" onClick={() => setOpen(true)} disabled={loading}>
        <img src={logoWhatsapp} alt="whatsapp" />
      </button>
    </div>
  );
};
export default WhatsAppFlotante;
